import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { mediaQueries } from '../../../api/media'
import { MediaGalleryModal } from './MediaGalleryModal'

interface MediaGalleryModalByIdsProps {
  show: boolean
  close: () => void
  mediaIds: string[]
  mediaGalleryIndex?: number
  setMediaGalleryIndex?: React.Dispatch<React.SetStateAction<number>>
}

export const MediaGalleryModalByIds = ({
  show,
  close,
  mediaIds,
  mediaGalleryIndex = 0,
  setMediaGalleryIndex,
}: MediaGalleryModalByIdsProps): JSX.Element => {
  const selectedMediaId = mediaIds[mediaGalleryIndex]
  const { data: selectedMedia } = useQuery({
    ...mediaQueries.getMedia(selectedMediaId),
    enabled: show && !!selectedMediaId,
  })

  const media = mediaIds.map((id) =>
    id === selectedMediaId
      ? { id, url: selectedMedia?.url, createdAt: selectedMedia?.createdAt }
      : { id }
  )

  return (
    <MediaGalleryModal
      show={show}
      close={close}
      media={media}
      mediaGalleryIndex={mediaGalleryIndex}
      setMediaGalleryIndex={setMediaGalleryIndex}
    />
  )
}
